<template>
  <path
    class="top"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17 10.835C15.8954 10.835 15 11.7304 15 12.835V14.1683C15 14.6285 15.3731 15.0016 15.8333 15.0016C16.2936 15.0016 16.6667 14.6285 16.6667 14.1683V13.5016C16.6667 12.9493 17.1144 12.5016 17.6667 12.5016H22.3333C22.8856 12.5016 23.3333 12.9493 23.3333 13.5016V14.1683C23.3333 14.6285 23.7064 15.0016 24.1667 15.0016C24.6269 15.0016 25 14.6285 25 14.1683V12.835C25 11.7304 24.1046 10.835 23 10.835H17ZM12 15.835C10.8954 15.835 10 16.7304 10 17.835V19.0016C10 19.5539 10.4477 20.0016 11 20.0016H29C29.5523 20.0016 30 19.5539 30 19.0016V17.835C30 16.7304 29.1046 15.835 28 15.835H12Z"
    fill="currentColor"
  />
  <path
    class="bottom"
    d="M10 21.835C10 21.2827 10.4477 20.835 11 20.835H29C29.5523 20.835 30 21.2827 30 21.835V27.1683C30 28.2729 29.1046 29.1683 28 29.1683H12C10.8954 29.1683 10 28.2729 10 27.1683V21.835Z"
    fill="currentColor"
  />
</template>
